var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSave = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M5 21h14c1.103 0 2-.897 2-2V8a1 1 0 0 0-.293-.707l-4-4A1 1 0 0 0 16 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2m10-2H9v-5h6zM13 7h-2V5h2zM5 5h2v4h8V5h.586L19 8.414 19.001 19H17v-5c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v5H5z"
})));
export default SvgSave;